import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

// Shared Home affordance for the active Sim #2 experience (HUD style, left side — same meaning as Sim #1:
// Home = Adaptience landing page). It is the ONLY navigation: it leaves the experience without touching the
// persisted attempt, so the public route resumes it later.
export const WildRushHome = ({ className = "" }) => {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => navigate("/")}
      aria-label="Home"
      title="Home"
      data-testid="wr-home"
      className={`flex h-9 w-9 items-center justify-center rounded-full border border-white/15 bg-black/35 text-white/85 backdrop-blur transition-colors hover:bg-black/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4FA3D9] ${className}`}
    >
      <Home size={15} />
    </button>
  );
};

export default WildRushHome;
